<div class="header">
    <div class="header-left">
        <a [routerLink]="routes.adminDashboard" class="logo">
            <img src="assets/img/LogoSipe.svg" width="80" height="80" alt="">
        </a>
    </div>
    <a (click)="toggleSideBar()" id="toggle_btn" href="javascript:void(0);"><img src="assets/img/icons/bar-icon.svg"
            alt=""></a>
    <a (click)="toggleMobileSideBar()" href="javascript:void(0);" aria-label="Abrir o cerrar menú lateral" id="mobile_btn" class="mobile_btn float-start"><img
            src="assets/img/icons/bar-icon.svg" alt=""></a>
    <button type="button" class="mobile-search-toggle btn" (click)="mobileSearchOpen = !mobileSearchOpen"
        [attr.aria-expanded]="mobileSearchOpen" aria-controls="global-search" aria-label="Abrir o cerrar búsqueda">
        <i class="fas fa-search" aria-hidden="true"></i>
    </button>
    <div id="global-search" class="top-nav-search mob-view" [class.mobile-search-open]="mobileSearchOpen">
        <form>
            <input type="search" class="form-control" placeholder="Buscar aquí" aria-label="Buscar en SIPE" [formControl]="searchControl">
            <a class="btn"><img src="assets/img/icons/search-normal.svg" alt=""></a>
        </form>
        <div class="global-search-box" *ngIf="resultadosGlobales.length > 0 || buscandoGlobal">
            <div class="global-search-loading" *ngIf="buscandoGlobal">
                Buscando...
            </div>

            <div class="global-search-item" *ngFor="let item of resultadosGlobales" (click)="irAResultado(item)">

                <strong>{{ item.titulo }}</strong>
                <span>{{ item.tipo }}</span>
                <small>{{ item.descripcion }}</small>
            </div>
        </div>
    </div>
    <ul class="nav user-menu float-end">
        <li class="nav-item dropdown mobile-notifications">
            <!-- <img src="assets/img/icons/note-icon-02.svg" alt=""> -->
            <a href="javascript:void(0);" class="dropdown-toggle nav-link" data-bs-toggle="dropdown" aria-label="Notificaciones"><img
                    src="assets/img/icons/note-icon-01.svg" alt=""><span class="pulse"></span>
                <span class="pulse" *ngIf="noLeidas > 0"></span>
                <span class="badge bg-danger" *ngIf="noLeidas > 0">{{ noLeidas }}</span>
            </a>

            <div class="dropdown-menu notifications">
                <div class="topnav-dropdown-header">
                    <div class="d-flex justify-content-between align-items-center">
                        <span>Notificaciones</span>
                        <div class="noti-header-actions" *ngIf="notificaciones.length > 0">
                            <a href="javascript:void(0);" class="me-2" (click)="marcarTodasComoLeidas()">Marcar
                                todo como leídas</a>
                            <a href="javascript:void(0);" data-bs-toggle="modal"
                                data-bs-target="#borrar_notificaciones">Borrar</a>
                        </div>
                    </div>
                </div>
                <div class="px-3 py-2 text-warning" *ngIf="notificacionesError" role="status">
                    {{ notificacionesError }}
                    <button type="button" class="btn btn-sm btn-outline-secondary mt-1" [disabled]="notificacionesCargando" (click)="cargarNotificaciones(); $event.stopPropagation()">Reintentar</button>
                </div>
                <div class="drop-scroll">
                    <ul class="notification-list">
                        <li class="notification-message" *ngIf="notificaciones.length === 0 && !notificacionesError && !notificacionesCargando">
                            <a href="javascript:void(0);">
                                <div class="media">
                                    <div class="media-body">
                                        <p class="noti-details">No tienes notificaciones.</p>
                                    </div>
                                </div>
                            </a>
                        </li>

                        <li class="notification-message" *ngFor="let item of notificaciones"
                            [class.bg-light]="!item.leida" (click)="navegarNotificacion(item)">
                            <a href="javascript:void(0);">
                                <div class="media">
                                    <span class="avatar">
                                        {{ item.titulo ? item.titulo.charAt(0) : 'N' }}
                                    </span>

                                    <div class="media-body">
                                        <p class="noti-details">
                                            <span class="noti-title">{{ item.titulo }}</span>
                                            {{ item.mensaje }}
                                        </p>

                                        <p class="noti-time">
                                            <span class="notification-time">
                                                {{ item.created_at | date:'dd/MM/yyyy HH:mm' }}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="topnav-dropdown-footer">
                    <a [routerLink]="routes.activities">Ver todas las notificaciones</a>
                </div>
            </div>
        </li>
        <!-- <li class="nav-item dropdown d-none d-sm-block">
            <a (click)="openBoxFunc()"  id="open_msg_box" class="hasnotifications nav-link"><img src="assets/img/icons/note-icon-01.svg" alt=""><span class="pulse"></span> </a>
        </li> -->
        <li class="nav-item dropdown has-arrow user-profile-list">
            <a href="javascript:void(0);" class="dropdown-toggle nav-link user-link" data-bs-toggle="dropdown">
                <div class="user-names">
                    <h5>{{ user.name }}</h5>
                    <span>{{ user.roles }}</span>
                </div>
                <span class="user-img">
                    <img [src]="user.foto" alt="Admin">
                </span>
            </a>
            <div class="dropdown-menu">
                <a class="dropdown-item" [routerLink]="[ '../../usuarios/list-usuarios/profile-usuarios/',user.id]">Mi
                    perfil</a>
                <a class="dropdown-item" [routerLink]="[ '../../usuarios/list-usuarios/edit-usuarios/',user.id]">Editar
                    perfil</a>
                <a class="dropdown-item" [routerLink]="routes.settings" *ngIf="puedeVerSettings">Configuración</a>
                <a class="dropdown-item" href="#" onclick="return false " (click)="logout();">Cerrar sesión</a>
            </div>
        </li>
        <!-- <li class="nav-item ">
            <a [routerLink]="routes.settings" class="hasnotifications nav-link"><img
                    src="assets/img/icons/setting-icon-01.svg" alt=""> </a>
        </li> -->
    </ul>
    <div class="dropdown mobile-user-menu float-end">
        <a href="javascript:void(0);" class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><i
                class="fa-solid fa-ellipsis-vertical"></i></a>
        <div class="dropdown-menu dropdown-menu-end">
            <a class="dropdown-item" [routerLink]="[ '../../usuarios/list-usuarios/profile-usuarios/',user.id]">Mi perfil</a>
            <a class="dropdown-item" [routerLink]="[ '../../usuarios/list-usuarios/edit-usuarios/',user.id]">Editar perfil</a>
            <a class="dropdown-item" [routerLink]="routes.settings" *ngIf="puedeVerSettings">Configuraciones</a>
            <a class="dropdown-item" href="#" onclick="return false " (click)="logout();">Cerrar sesión</a>
        </div>
    </div>
</div>

<!--modal para borrar-->    
<div id="borrar_notificaciones" class="modal fade delete-modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body text-center">
                <img src="assets/img/sent.png" alt="" width="50" height="46">
                <h3>¿Eliminar todas tus notificaciones?</h3>
                <p>Esta acción no se puede deshacer desde aquí.</p>
                <div class="m-t-20">
                    <a href="javascript:void(0);" class="btn btn-white me-1" data-bs-dismiss="modal">Cancelar</a>
                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                        (click)="borrarTodas()">Eliminar</button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="notification-box">
    <div class="msg-sidebar notifications msg-noti">
        <div class="topnav-dropdown-header">
            <span>Mensajes</span>
        </div>
        <div class="drop-scroll msg-list-scroll" id="msg_list">
            <ul class="list-box">
                <li>
                    <a [routerLink]="routes.chat">
                        <div class="list-item">
                            <div class="list-left">
                                <span class="avatar">R</span>
                            </div>
                            <div class="list-body">
                                <span class="message-author">Richard Miles </span>
                                <span class="message-time">12:28 AM</span>
                                <div class="clearfix"></div>
                                <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a [routerLink]="routes.chat">
                        <div class="list-item new-message">
                            <div class="list-left">
                                <span class="avatar">J</span>
                            </div>
                            <div class="list-body">
                                <span class="message-author">John Doe</span>
                                <span class="message-time">1 Aug</span>
                                <div class="clearfix"></div>
                                <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a [routerLink]="routes.chat">
                        <div class="list-item">
                            <div class="list-left">
                                <span class="avatar">T</span>
                            </div>
                            <div class="list-body">
                                <span class="message-author"> Tarah Shropshire </span>
                                <span class="message-time">12:28 AM</span>
                                <div class="clearfix"></div>
                                <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a [routerLink]="routes.chat">
                        <div class="list-item">
                            <div class="list-left">
                                <span class="avatar">M</span>
                            </div>
                            <div class="list-body">
                                <span class="message-author">Mike Litorus</span>
                                <span class="message-time">12:28 AM</span>
                                <div class="clearfix"></div>
                                <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a [routerLink]="routes.chat">
                        <div class="list-item">
                            <div class="list-left">
                                <span class="avatar">C</span>
                            </div>
                            <div class="list-body">
                                <span class="message-author"> Catherine Manseau </span>
                                <span class="message-time">12:28 AM</span>
                                <div class="clearfix"></div>
                                <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a [routerLink]="routes.chat">
                        <div class="list-item">
                            <div class="list-left">
                                <span class="avatar">D</span>
                            </div>
                            <div class="list-body">
                                <span class="message-author"> Domenic Houston </span>
                                <span class="message-time">12:28 AM</span>
                                <div class="clearfix"></div>
                                <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a [routerLink]="routes.chat">
                        <div class="list-item">
                            <div class="list-left">
                                <span class="avatar">B</span>
                            </div>
                            <div class="list-body">
                                <span class="message-author"> Buster Wigton </span>
                                <span class="message-time">12:28 AM</span>
                                <div class="clearfix"></div>
                                <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a [routerLink]="routes.chat">
                        <div class="list-item">
                            <div class="list-left">
                                <span class="avatar">R</span>
                            </div>
                            <div class="list-body">
                                <span class="message-author"> Rolland Webber </span>
                                <span class="message-time">12:28 AM</span>
                                <div class="clearfix"></div>
                                <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a [routerLink]="routes.chat">
                        <div class="list-item">
                            <div class="list-left">
                                <span class="avatar">C</span>
                            </div>
                            <div class="list-body">
                                <span class="message-author"> Claire Mapes </span>
                                <span class="message-time">12:28 AM</span>
                                <div class="clearfix"></div>
                                <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a [routerLink]="routes.chat">
                        <div class="list-item">
                            <div class="list-left">
                                <span class="avatar">M</span>
                            </div>
                            <div class="list-body">
                                <span class="message-author">Melita Faucher</span>
                                <span class="message-time">12:28 AM</span>
                                <div class="clearfix"></div>
                                <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a [routerLink]="routes.chat">
                        <div class="list-item">
                            <div class="list-left">
                                <span class="avatar">J</span>
                            </div>
                            <div class="list-body">
                                <span class="message-author">Jeffery Lalor</span>
                                <span class="message-time">12:28 AM</span>
                                <div class="clearfix"></div>
                                <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a [routerLink]="routes.chat">
                        <div class="list-item">
                            <div class="list-left">
                                <span class="avatar">L</span>
                            </div>
                            <div class="list-body">
                                <span class="message-author">Loren Gatlin</span>
                                <span class="message-time">12:28 AM</span>
                                <div class="clearfix"></div>
                                <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                            </div>
                        </div>
                    </a>
                </li>
                <li>
                    <a [routerLink]="routes.chat">
                        <div class="list-item">
                            <div class="list-left">
                                <span class="avatar">T</span>
                            </div>
                            <div class="list-body">
                                <span class="message-author">Tarah Shropshire</span>
                                <span class="message-time">12:28 AM</span>
                                <div class="clearfix"></div>
                                <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
        <div class="topnav-dropdown-footer">
            <a [routerLink]="routes.chat">Ver mas mensajes</a>
        </div>
    </div>
</div> -->
